var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 31,
    rx: 5.5,
    stroke: "#DFE3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7383 9.43203L26.8099 10.079V7.63496L29.7383 7V9.43203Z",
    fill: "#6461FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8281 10.7858C34.6847 10.7858 33.9497 11.3369 33.5414 11.7203L33.3897 10.9775H30.8231V24.9467L33.7397 24.3117L33.7514 20.9213C34.1714 21.2328 34.7897 21.676 35.8164 21.676C37.9047 21.676 39.8064 19.9509 39.8064 16.1531C39.7947 12.6787 37.8697 10.7858 35.8281 10.7858ZM35.128 19.0403C34.4397 19.0403 34.0313 18.7887 33.7513 18.4772L33.7397 14.0325C34.043 13.6851 34.463 13.4455 35.128 13.4455C36.1897 13.4455 36.9247 14.6675 36.9247 16.2369C36.9247 17.8423 36.2013 19.0403 35.128 19.0403Z",
    fill: "#6461FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 16.2729C49 13.2059 47.5533 10.7858 44.7883 10.7858C42.0117 10.7858 40.3317 13.2059 40.3317 16.2489C40.3317 19.855 42.315 21.676 45.1617 21.676C46.55 21.676 47.6 21.3526 48.3933 20.8973V18.5012C47.6 18.9085 46.69 19.1601 45.535 19.1601C44.4033 19.1601 43.4 18.7528 43.2717 17.3391H48.9767C48.9767 17.2731 48.9809 17.1231 48.9857 16.9502C48.9923 16.7154 49 16.4385 49 16.2729ZM43.2367 15.1347C43.2367 13.7809 44.0417 13.2178 44.7767 13.2178C45.4883 13.2178 46.2467 13.7809 46.2467 15.1347H43.2367Z",
    fill: "#6461FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8099 10.9895H29.7383V21.4724H26.8099V10.9895Z",
    fill: "#6461FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4851 10.9895L23.6718 11.876C24.3601 10.5822 25.7251 10.8457 26.0984 10.9895V13.745C25.7368 13.6132 24.5701 13.4455 23.8818 14.368V21.4724H20.9651V10.9895H23.4851Z",
    fill: "#6461FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8383 8.38971L14.9916 9.0127L14.9799 18.609C14.9799 20.3821 16.2749 21.688 18.0016 21.688C18.9583 21.688 19.6583 21.5083 20.0433 21.2926V18.8606C19.6699 19.0164 17.8266 19.5675 17.8266 17.7944V13.5413H20.0433V10.9895H17.8266L17.8383 8.38971Z",
    fill: "#6461FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9433 13.3856C10.325 13.3856 9.95167 13.5653 9.95167 14.0325C9.95167 14.5427 10.5942 14.7671 11.3913 15.0455C12.6908 15.4994 14.4011 16.0967 14.4084 18.3096C14.4084 20.4541 12.74 21.688 10.3133 21.688C9.31001 21.688 8.21334 21.4844 7.12833 21.0052V18.1538C8.10834 18.7049 9.34501 19.1123 10.3133 19.1123C10.9667 19.1123 11.4333 18.9325 11.4333 18.3814C11.4333 17.8164 10.7368 17.5581 9.89598 17.2462C8.61541 16.7713 7 16.1723 7 14.1763C7 12.0558 8.575 10.7858 10.9433 10.7858C11.9117 10.7858 12.8683 10.9416 13.8367 11.3369V14.1523C12.95 13.6611 11.83 13.3856 10.9433 13.3856Z",
    fill: "#6461FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.66c07ea62ccefb2677dae7568032f9e4.svg";
export { ForwardRef as ReactComponent };